import React from 'react'
import { Alert, Button, Modal, Form } from 'react-bootstrap'

export default function DeleteBurgerPlace({
	showDeleteBurgerPlace,
	handleCloseDeleteBurgerPlace,
	deleteNameRef,
	burgerPlaces,
	loadingDeleteBurgerPlace,
	handleSubmitDeleteBurgerPlace,
	errorDeleteBurgerPlace,
}) {
	return (
		<Modal show={showDeleteBurgerPlace} onHide={handleCloseDeleteBurgerPlace}>
			<Modal.Header closeButton>
				<Modal.Title>Slett burgerplass</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<Form>
					<Form.Group className="mb-3" controlId="deleteBurgerPlaceForm.ControlInput1">
						<Form.Label>Burgerplass</Form.Label>
						<Form.Select custom="true" ref={deleteNameRef}>
							{burgerPlaces
								?.sort((a, b) => a.displayName.localeCompare(b.displayName))
								.map((burgerPlace, index) => (
									<option key={index} value={burgerPlace.id}>
										{burgerPlace.displayName}
									</option>
								))}
						</Form.Select>
					</Form.Group>
				</Form>
			</Modal.Body>
			<Modal.Footer>
				{errorDeleteBurgerPlace && <Alert variant="danger">{errorDeleteBurgerPlace}</Alert>}
				<Button variant="secondary" onClick={handleCloseDeleteBurgerPlace}>
					Avbryt
				</Button>
				<Button
					disabled={loadingDeleteBurgerPlace}
					className="dark-blue-button"
					onClick={handleSubmitDeleteBurgerPlace}
				>
					Slett burgerplass
				</Button>
			</Modal.Footer>
		</Modal>
	)
}
